import highlightWords from 'utils/highlight_words';

const HighlightMatch = ({
  text,
  subtext,
  matchWords = false,
}: {
  text: string;
  subtext: string;
  matchWords?: boolean;
}) => {
  if (!subtext) return <>{text}</>;

  if (matchWords) {
    return (
      <>
        {highlightWords(text, subtext).map((segment, index) =>
          segment.isMatch ? <strong key={index}>{segment.text}</strong> : segment.text,
        )}
      </>
    );
  }

  const lowerText = text.toLowerCase();
  const lowerSub = subtext.toLowerCase();
  const matchIndex = lowerText.indexOf(lowerSub);

  if (matchIndex === -1) return <>{text}</>;

  const start = text.slice(0, matchIndex);
  const match = text.slice(matchIndex, matchIndex + subtext.length);
  const end = text.slice(matchIndex + subtext.length);

  return (
    <>
      {start}
      <strong>{match}</strong>
      {end}
    </>
  );
};

export default HighlightMatch;
